import { SchemaBuilder } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class WebSiteSchemaBuilder implements SchemaBuilder {
  constructor(protected winRef: WindowRef) {}

  build(): Observable<any> {
    return of(this.collect());
  }

  protected collect(): any {
    return {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      name: 'Hisense',
      url: this.winRef.location.origin,
    };
  }
}
